import React, { useEffect } from 'react';
import { LuMail } from 'react-icons/lu';
import Navbar from './Navbar';
import { CONTACT_EMAIL } from '../data/site';

const PrivacyPage = () => {
  useEffect(() => {
    document.title = 'Privacy | Tre Lune';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Informativa privacy di Tre Lune Technologies. Come trattiamo i dati del form di contatto.'
      );
    }
  }, []);

  return (
    <div className="App">
      <Navbar />

      <section className="section privacy-page">
        <div className="container">
          <article className="glass-panel privacy-article">
            <h1 className="text-gradient">Informativa privacy</h1>
            <p className="section-subtitle">
              Informazioni sul trattamento dei dati personali raccolti da questo sito.
            </p>

            <h2>Titolare del trattamento</h2>
            <p>
              Tre Lune Technologies
              <br />
              P.IVA 08740380723
              <br />
              Vico Mario Pagano 6, 72024 Oria (BR)
              <br />
              Email: <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            </p>

            <h2>Dati del form di contatto</h2>
            <p>
              I dati che invii dal form (nome, recapito, attività, tipo di richiesta e messaggio)
              sono usati solo per rispondere alla tua richiesta e gestire il preventivo o il
              contatto successivo. Non li cediamo a terzi per finalità di marketing.
            </p>
            <p>
              Li conserviamo per il tempo necessario a evadere la richiesta e gli eventuali
              obblighi di legge connessi.
            </p>

            <h2>I tuoi diritti</h2>
            <p>
              Per accesso, rettifica o cancellazione dei dati relativi a una richiesta, scrivi a{' '}
              <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
            </p>
          </article>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <span className="text-gradient footer-brand">Tre Lune Technologies</span>
              <div className="footer-contacts">
                <a href={`mailto:${CONTACT_EMAIL}`}>
                  <LuMail aria-hidden="true" /> {CONTACT_EMAIL}
                </a>
              </div>
            </div>
            <nav className="footer-links" aria-label="Piè di pagina">
              <a href="/">Tre Lune</a>
              <a href="/#contatti">Contatti</a>
            </nav>
            <p className="footer-copy">© 2026 Tre Lune Technologies. P.IVA 08740380723</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
